// @ts-check
import './shape.css';
import { h } from 'preact';

/**
 * @param {object} props
 * @param {string} props.id
 * @param {SVGRect=} props.bBox
 * @param {string} props.status
 * @param {{ elementTagName: string, points?: string, d?: string, width?: string|number, height?: string|number, x?: string|number, y?: string|number}[]} props.elements
 * @param {boolean=} props.isMatch
 * @param {boolean=} props.isSelected
 * @param {boolean=} props.isHighlighted
 * @param {h.JSX.MouseEventHandler<HTMLAnchorElement>=} props.onMouseEnter
 * @param {h.JSX.MouseEventHandler<HTMLAnchorElement>=} props.onMouseLeave
 * @param {(shapeId: string, bBox: SVGRect) => void=} props.handleClick
 * @param {(shapeId: string, bBox: SVGRect) => void=} props.handleMouseEnter
 * @param {(shapeId: string, bBox: SVGRect) => void=} props.handleMouseLeave
 * @returns
 */
export default function Shape({ id, bBox, status, elements, isMatch = true, isSelected = false, isHighlighted = false, onMouseEnter, onMouseLeave, handleClick, handleMouseEnter, handleMouseLeave }) {
	function onClick(event) {
		event.preventDefault();
		event.stopPropagation();
		if (typeof handleClick === 'function') {
			handleClick(id, bBox);
		}
	}

	function onMouseEnterHandler(e) {
		if (typeof onMouseEnter === 'function') {
			onMouseEnter(e);
		}

		if (typeof handleMouseEnter === 'function') {
			handleMouseEnter(id, bBox);
		}
	}

	function onMouseLeaveHandler(e) {
		if (typeof onMouseLeave === 'function') {
			onMouseLeave(e);
		}

		if (typeof handleMouseLeave === 'function') {
			handleMouseLeave(id, bBox);
		}
	}

	function getSvgElement({ elementTagName, points, d, height, width, x, y, index }) {
		switch (elementTagName) {
		case 'polygon':
			return <polygon key={index} className="shape" points={points} />;
		case 'path':
			return <path key={index} className="shape" d={d} />;
		case 'rect':
			return <rect key={index} className="shape" height={height} width={width} x={x} y={y} />;
		}
	}

	return (
		<a
			id={id}
			onClick={onClick}
			onMouseEnter={onMouseEnterHandler}
			onMouseLeave={onMouseLeaveHandler}
			xlinkHref="#"
			className={`shape-container status-${status}${isMatch ? ' is-match' : ''}${isSelected ? ' is-selected' : ''}${isHighlighted ? ' is-highlighted' : ''}`}
		>
			<g>
				{elements.map((element, index) => getSvgElement({ ... element, index }))}
			</g>
		</a>
	);
}
